// extracted by mini-css-extract-plugin
var _1 = "AIButtonIcon-moduleaiButtonIcon__WNIqX";
export { _1 as "aiButtonIcon" }
